import React from "react";
import "../styles/ComoFunciona.css";
import { FaSearch, FaBrain, FaChessKnight, FaRocket } from "react-icons/fa";

const passos = [
  {
    icon: <FaSearch />,
    title: "Análise inteligente",
    desc: "O ARC analisa seu histórico de atendimentos, agendamentos e faturamento para entender o comportamento operacional.",
  },
  {
    icon: <FaBrain />,
    title: "Insights personalizados",
    desc: "Com base nas metas e desempenho, a IA sugere ações práticas para melhorar seus resultados diariamente.",
  },
  {
    icon: <FaChessKnight />,
    title: "Atuação estratégica",
    desc: "Mais do que um sistema, o ARC pensa como gestor: identifica gargalos, propõe soluções e ajuda sua equipe a tomar decisões certeiras.",
  },
  {
    icon: <FaRocket />,
    title: "Evolução contínua",
    desc: "A cada nova informação, o ARC aprende e se adapta, tornando suas análises e projeções mais inteligentes a cada dia.",
  },
];

const ComoFunciona = () => {
  return (
    <section className="como-funciona-section" id="beneficios">
      <h2 className="como-funciona-title">Como o ARC ajuda no dia a dia?</h2>
      <div className="passos-container">
        {passos.map((passo, index) => (
          <div key={index} className="passo-card">
            <div className="passo-icon">{passo.icon}</div>
            <h3 className="passo-title">{passo.title}</h3>
            <p className="passo-desc">{passo.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ComoFunciona;
